<template>
  <div class="appeal-container">
    <div class="main-container">
      <div class="main">
        <div class="guidance">
          <div class="title">Infringement Appeal Guidelines</div>
          <div class="content">
            <p>
              As a neutral network service provider, Yichuang Community only provides users with information storage space. Yichuang Community users register on Yichuang Community and publish content, provide goods or services on their own. Yichuang Community cannot pre-review users' infringement situations and does not provide any form of guarantee for the content published by users on the platform.
            </p>

            <p>
              In order to help you protect your legitimate rights and interests, Yichuang Community has formulated and provided you with these guidelines. Please read them carefully. If you believe that users, notes, products, live broadcasts, etc. in Yichuang Community contain content that infringes your legitimate rights and interests, please fill in the form according to these guidelines and submit your complaint to Yichuang Community.
            </p>
            <p>
              <span>*Please be sure to understand that,</span
              >infringement complaints are a serious legal act. Yichuang Community strictly reviews and handles your infringement complaints in accordance with the relevant provisions of the Civil Code, E-Commerce Law, Regulations on the Protection of the Right to Disseminate Information through Networks, and other relevant laws and regulations. If you fail to exercise your rights in accordance with the requirements shown in these guidelines, your infringement complaint will not be accepted.
            </p>
          </div>
        </div>
        <div class="appeal-form">
          <div class="form-title">Infringement Appeal Form</div>
          <div class="form-group-title">Rights Holder Basic Information</div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">Rights Holder Name:</div>
              <input v-model="form.name" placeholder="Please enter the rights holder's name" />
            </div>
            <div class="form-item">
              <div class="form-item-label required">Rights Holder ID Number:</div>
              <input
                v-model="form.id_no"
                placeholder="Please enter the rights holder's ID number"
              />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">Contact Phone:</div>
              <input v-model="form.phone" placeholder="Please enter the contact phone number" />
            </div>
            <div class="form-item">
              <div class="form-item-label required">Contact Email:</div>
              <input v-model="form.email" placeholder="Please enter the contact email" />
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">Contact Address:</div>
              <input
                v-model="form.address"
                placeholder="Please enter the detailed contact address"
              />
            </div>
          </div>
          <div class="form-group-title">Complaint Facts and Reasons</div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">Complaint Content</div>
              <div class="input-group">
                <input v-model="form.author_name" placeholder="Publisher Name" />
                <input v-model="form.post_title" placeholder="Note Title" />
                <input v-model="form.post_url" placeholder="Note Link Address" />
              </div>
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">Complaint Reason</div>
              <div class="reason-box">
                <div class="reason-item">
                  <div class="reason-label">Natural Person Rights (Multiple Selection)</div>
                  <div class="reason-check-box" style="margin-left: 39px">
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Defamation')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Defamation')"
                        @click="onReasonClick('Defamation')"
                      />
                      <Icon
                        @click="onReasonClick('Defamation')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Defamation</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Portrait Rights, Privacy Leak')"
                        type="checkbox"
                        :checked="
                          form.appeal_reason.includes('Portrait Rights, Privacy Leak')
                        "
                        @click="onReasonClick('Portrait Rights, Privacy Leak')"
                      />
                      <Icon
                        @click="onReasonClick('Portrait Rights, Privacy Leak')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Portrait Rights, Privacy Leak</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Impersonating Personal Account')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Impersonating Personal Account')"
                        @click="onReasonClick('Impersonating Personal Account')"
                      />
                      <Icon
                        @click="onReasonClick('Impersonating Personal Account')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Impersonating Personal Account</span>
                    </div>
                  </div>
                </div>
                <div class="reason-item">
                  <div class="reason-label">Intellectual Property Infringement (Multiple Selection)</div>
                  <div class="reason-check-box" style="margin-left: 25px">
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Trademark Infringement')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Trademark Infringement')"
                        @click="onReasonClick('Trademark Infringement')"
                      />
                      <Icon
                        @click="onReasonClick('Trademark Infringement')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Trademark Infringement</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Copyright Infringement')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Copyright Infringement')"
                        @click="onReasonClick('Copyright Infringement')"
                      />
                      <Icon
                        @click="onReasonClick('Copyright Infringement')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Copyright Infringement</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Patent Infringement')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Patent Infringement')"
                        @click="onReasonClick('Patent Infringement')"
                      />
                      <Icon
                        @click="onReasonClick('Patent Infringement')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Patent Infringement</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Trade Secrets')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Trade Secrets')"
                        @click="onReasonClick('Trade Secrets')"
                      />
                      <Icon
                        @click="onReasonClick('Trade Secrets')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Trade Secrets</span>
                    </div>
                  </div>
                </div>
                <div class="reason-item">
                  <div class="reason-label">Other Corporate Rights</div>
                  <div class="reason-check-box" style="margin-left: 76px">
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Reputation Damage')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Reputation Damage')"
                        @click="onReasonClick('Reputation Damage')"
                      />
                      <Icon
                        @click="onReasonClick('Reputation Damage')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Reputation Damage</span>
                    </div>
                    <div class="reason-check-item">
                      <input
                        v-if="!form.appeal_reason.includes('Impersonating Corporate Identity')"
                        type="checkbox"
                        :checked="form.appeal_reason.includes('Impersonating Corporate Identity')"
                        @click="onReasonClick('Impersonating Corporate Identity')"
                      />
                      <Icon
                        @click="onReasonClick('Impersonating Corporate Identity')"
                        type="md-checkbox"
                        color="#f84f5d"
                        size="22"
                        v-else
                      ></Icon>
                      <span>Impersonating Corporate Identity</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group-title" style="margin-bottom: 15px">
            Complaint Infringement Facts and Supporting Materials
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="desc require">
                Please upload proof images or materials that can prove the infringement facts in file form
              </div>
              <!-- :format="['jpg', 'jpeg', 'png', 'gif']"
                accept=".jpg,.jpeg,.png,.gif" -->
              <Upload
                class="img-upload-btn"
                :action="upload_url"
                :data="{ dir: 'template' }"
                multiple
                :on-success="
                  (response, file, fileList) =>
                    handleSuccess(response, file, fileList, 'img_list')
                "
                :show-upload-list="false"
              >
                <template>
                  <div class="up-btn">
                    <Icon type="md-add" size="32" color="#ffffff"></Icon>
                    <div class="upbtn-text">Upload Supporting Documents</div>
                  </div>
                </template>
              </Upload>
              <div class="file-list-box">
                <div
                  class="list-item"
                  v-for="(item, index) in form.file_list"
                  :key="index"
                >
                  <div class="item-box">
                    <div class="left">
                      <img
                        class="icon"
                        src="../../assets/images/icon-file.png"
                      />
                      <div class="file-name">{{ item.file_name }}</div>
                    </div>
                    <div class="right" @click="onRemoveFile(index)">
                      <Icon type="md-close-circle" size="26"></Icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item-box">
            <div class="form-item">
              <div class="form-item-label required">Infringement Fact Description</div>
              <textarea v-model="form.appeal_introduction" placeholder="Please enter the infringement fact description"></textarea>
            </div>
          </div>
          <div class="form-group-title" style="margin-bottom: 21px">
            Warranty Statement
          </div>
          <p>The rights holder (collectively referred to as: declarant) sincerely makes the following warranty statement:</p>
          <p>
            The statements and related materials provided by the declarant in the complaint form are all true, valid and legal. The declarant shall bear all consequences arising from this complaint form and related materials. The declarant guarantees to bear and compensate for all losses caused to Yichuang Community due to Yichuang Community deleting relevant content or disconnecting links to relevant services or content based on the declarant's complaint form, including but not limited to losses incurred by Yichuang Community due to compensation to the complained party or users and damage to Yichuang Community's reputation and goodwill.
          </p>
          <div class="agreement">
            <input type="checkbox" v-model="is_agree" />
            I have read and agree to the warranty statement content
          </div>
        </div>
        <div class="btn-box">
          <button @click="$router.back()">Cancel</button>
          <button @click="onSubmit">Submit Appeal</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SubmitAppeal } from "@/api/social";
export default {
  data() {
    return {
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      form: {
        name: "",
        id_no: "",
        phone: "",
        email: "",
        address: "",
        author_name: "",
        post_title: "",
        post_url: "",
        appeal_reason: [],
        file_list: [],
        appeal_introduction: "",
      },
      is_agree: false,
    };
  },
  mounted() {},
  methods: {
    async onSubmit() {
      try {
        const { form, is_agree } = this;
        if (!is_agree) {
          this.$layer.msg("Please agree to the warranty statement content first");
          return;
        }
        const { code, msg } = await SubmitAppeal(form);
        if (code > 0) {
          this.$layer.msg(msg);
        }else {
          this.$layer.msg("Submitted successfully, please wait for review");
          this.$router.push({name:'SubmitResult'});
          this.form = {
            name: "",
            id_no: "",
            phone: "",
            email: "",
            address: "",
            author_name: "",
            post_title: "",
            post_url: "",
            appeal_reason: [],
            file_list: [],
            appeal_introduction: "",
          }
        };
      } catch (e) {
        console.log("e", e);
        this.$layer.msg(e.msg);
      }
    },
    onRemoveFile(index) {
      this.form.file_list.splice(index, 1);
    },
    onReasonClick(data) {
      const index = this.form.appeal_reason.indexOf(data);
      if (index > -1) {
        // 如果已存在，则移除
        this.form.appeal_reason.splice(index, 1);
      } else {
        // 如果不存在，则推入
        this.form.appeal_reason.push(data);
      }
      console.log("form_appeal_reason", this.form);
    },
    handleSuccess(response, file, fileList, field) {
      console.log("response", response);
      console.log("file", file);
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')+1).toLowerCase();
      this.form.file_list.push({
        file_name: file.name,
        url: response.data.url,
        file_type:fileExtension
      });
      console.log('form',this.form.file_list);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./appeal.scss";
</style>
